import script from "./ImportJobsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportJobsPage.vue?vue&type=script&setup=true&lang=js"

import "./ImportJobsPage.vue?vue&type=style&index=0&id=b3d96b18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d96b18"]])

export default __exports__